import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { LoadState } from "../../constants/enums";

export interface IAcitivtyState {
  tasks: {
    list: IBusinessTask[];
    totalRecords: number;
    loading: LoadState;
    data: IBusinessTask[];
    dataLoading: LoadState;
    error: string | null;
  };
  emailConversation: {
    list: IEmailConversationActivity[];
    loading: LoadState;
    error: string | null;
  };
  sms: {
    list: ISMSActivity[];
    loading: LoadState;
    error: string | null;
  };
  whatsApp: {
    list: IWhatsAppActivity[];
    hasMoreRecords: boolean;
    loading: LoadState;
    error: string | null;
  };
  whatsAppGroup: {
    list: IWhatsAppGroupActivity[];
    hasMoreRecords: boolean;
    isGroupConnected: boolean;
    groups: IGroup[];
    loading: LoadState;
    error: string | null;
  };
  whatsappStatusCounts: {
    list: IWhatsAppStatusCount[];
    loading: LoadState;
  };
}

export interface IWhatsAppStatusCount {
  [key: string]: number;
}

export interface IGroup {
  id: string;
  name: string;
}

export interface ICreateGroupPayload {
  group_id: string;
  module_name: string;
  module_uuid: string;
  status: string;
}

export interface IEmailConversationActivity {
  email_history_code: string | null;
  email_conversation_id: string | null;
  module_code: string | null;
  module_name: string | null;
  subject: string | null;
  to_mail_ids: string[] | null;
  cc_mail_ids: string[] | null;
  bcc_mail_ids: string[] | null;
  body: { content: string | null };
  attachments: any | null;
  comment: string | null;
  send_received_ts: string | null;
  status: string;
  insert_ts: string;
}

export interface ISMSActivity {
  sms_history_id: number;
  sms_history_code: string;
  sms_conversation_id: string | null;
  module_name: string;
  module_code: string;
  recipients: {
    to: string;
    objectVariables: {
      [key: string]: string;
    };
  }[];
  template_name: string;
  comment: string | null;
  created_by_id: string;
  send_received_ts: string | null;
  create_ts: string;
  insert_ts: string;
}

export interface IWhatsAppActivity {
  sender_phone: string;
  sender_name: string;
  social_media_conversation_id: number;
  social_media_conversation_unique_id: number;
  social_media_conversation_uuid: string;
  conversation_id: string;
  socail_media_name: string;

  module_name: string;
  from_number: string;
  recipient_number: string;
  recipient_name?: string;
  message?: string;
  to_number: string;
  message_type: string;
  reply_from_conversation_id: string | null;
  content_type: string;
  content: (
    | {
        text: string;
        type: "BODY";
        is_restricted?: number | boolean;
      }
    | {
        type: "BUTTONS";
        text?: string;
        buttons: {
          text: string;
          type: string;
        }[];
      }
    | {
        type: "HEADER";
        text: "IMAGE HEADER" | "DOCUMENT HEADER";
        format: "DOCUMENT" | "IMAGE";
        example: {
          header_handle: string[];
        };
      }
    | {
        type: "FOOTER";
        text: string;
      }
  )[];

  attachments: any;
  raw_payload: any;
  is_automatic_message: number;
  is_restricted?: number | boolean;
  created_by_uuid: string | null;
  created_by_name: string | null;
  modified_by_uuid: string | null;
  modified_by_name: string | null;
  status: "SENT" | "READ" | "INITIATE" | "DELIVERED" | "SERVICE_OFF" | string;
  create_ts: string;
  insert_ts: string;
}
export interface IWhatsAppGroupActivity {
  module_name: string;
  from_number: string;
  message_type: string;
  content_type: string;
  content: (
    | {
        text: string;
        type: "BODY";
      }
    | {
        type: "BUTTONS";
        text?: string;
        buttons: {
          text: string;
          type: string;
        }[];
      }
  )[];
  attachments: any;
  raw_payload: any;
  is_automatic_message: number;
  created_by_uuid: string | null;
  created_by_name: string | null;
  modified_by_uuid: string | null;
  modified_by_name: string | null;
  status: string;
  create_ts: string;
  insert_ts: string;
  whatsapp_group_message_unique_id: number;
  whatsapp_group_message_uuid: string;
  module_uuid: string | null;
  group_id: string | null;
  group_name: string | null;
  from_name: string | null;
  quoted_message_id: string | null;
}

export interface IWhatsAppActivityPayload {
  message?: string;
  fromNumber: string | null;
  toNumber: string;
  is_automatic_message: number;
  reply_from_conversation_id?: string | null;
  templateName?: string | null;
  company_outlet_uuid: string;
  company_outlet_name: string;
  whatsapp_web_service?: boolean | null;
  objectVariables?: {
    bodyVar?: {
      type: string;
      value: string;
    }[];
  };
  image?: {
    link: string;
  };
  document?: {
    link: string;
    caption: string;
  };
  video?: {
    link: string;
    caption: string;
  };
  location?: {
    latitude: number;
    longitude: number;
    name: string;
    address: string;
  };
  attachments?: IFileUpload[] | null;
  reference_uuid_column_name?: string;
  reference_uuid_column_value?: string;
}

export interface IWhatsAppGroupActivityPayload {
  message?: string;
  fromNumber: string | null;
  toNumber: string;
  is_automatic_message: 0;
  templateName: string;
  objectVariables: {
    bodyVar: {
      type: string;
      value: string;
    }[];
  };
}

export interface IRestrictWhatsAppMessagePayload {
  restricted_words_uuid: string | null;
  word: string;
  company_outlet_uuid: string;
  status: "ACTIVE" | "INACTIVE";
}

export interface IBusinessTask {
  task_module_wise_code: string | null;
  module_name: string | null;
  sub_module_name: string | null;
  module_reference_column: string | null;
  module_reference_code_or_id: string | null;
  task_name: string | null;
  description: string | null;
  due_date: string | null;
  assigned_to_id: string | null;
  assigned_to_name: string | null;
  task_completed_date: string | null;
  task_priority: string | null;
  created_by_id: number | null;
  created_by_name: string | null;
  status: string;
  create_ts?: any;
  task_type: string | null;
}

export const INITIAL_BUSINESS_TASK: IBusinessTask = {
  task_module_wise_code: null,
  module_name: null,
  sub_module_name: null,
  module_reference_column: null,
  module_reference_code_or_id: null,
  task_name: null,
  description: null,
  due_date: null,
  assigned_to_id: null,
  task_completed_date: null,
  task_priority: null,
  assigned_to_name: null,
  created_by_name: null,
  created_by_id: null,
  task_type: null,
  status: "ACTIVE",
};

export const initialAcitvityState: IAcitivtyState = {
  tasks: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    data: [],
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  emailConversation: {
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  sms: {
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  whatsApp: {
    list: [],
    loading: LoadState.NotLoaded,
    hasMoreRecords: false,
    error: null,
  },
  whatsAppGroup: {
    list: [],
    loading: LoadState.NotLoaded,
    hasMoreRecords: false,
    isGroupConnected: false,
    groups: [],
    error: null,
  },
  whatsappStatusCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
};
